import { render } from "./TestArea.vue?vue&type=template&id=9fdfdbfc"
import script from "./TestArea.vue?vue&type=script&lang=js"
export * from "./TestArea.vue?vue&type=script&lang=js"

import "./TestArea.vue?vue&type=style&index=0&id=9fdfdbfc&lang=css"
script.render = render

export default script